import { IsBoolean, IsEmail, Equals } from 'class-validator';
import { ConsentStatus } from '../../enums';

export class RequestConsentDto {
	@IsEmail()
	parentEmail: string;
}

export class ChangeParentEmailDto {
	@IsEmail()
	parentEmail: string;
}

export class ApproveConsentDto {
	@IsBoolean()
	@Equals(true)
	consent: boolean;
}

export type ConsentTokenState = 'valid' | 'expired' | 'used' | 'invalid';

export interface ConsentStudentSummaryDto {
	username: string | null;
	age: number | null;
	event: string;
	cost: string;
}

export interface ConsentTokenResolveDto {
	state: ConsentTokenState;
	student?: ConsentStudentSummaryDto;
}

export interface ConsentStatusResponseDto {
	status: ConsentStatus;
	parentEmail: string;
	expiresAt: Date | null;
}
